import React from 'react';

import {NextStepLink} from './NextStepLink';

import {AnyStepType} from 'sweet-types';

interface Props<S extends AnyStepType> {
  step: S;
  steps: Array<S>;
}

export function NextStepLinkItem<S extends AnyStepType>({
  step,
  steps,
}: Props<S>) {
  return (
    <div className="d-flex flex-wrap justify-content-between">
      <div className="mb-2">
        {!step.type ||
        step.type === 'content' ||
        step.type === 'processprocedure' ? (
          <NextStepLink
            next={'next' in step ? step.next : undefined}
            steps={steps}
          />
        ) : null}
      </div>
    </div>
  );
}
